"use client";

import { useState } from "react";
import Image from "next/image";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface Banner { id: string; title: string; subtitle: string | null; image_url: string; link_url: string | null; }

export default function CatalogBanner({ banners }: { banners: Banner[] }) {
  const [current, setCurrent] = useState(0);
  const count = banners.length;
  if (!count) return null;

  const b = banners[current];
  const Wrapper = b.link_url ? "a" : "div";
  const wrapperProps = b.link_url ? { href: b.link_url, target: "_blank", rel: "noreferrer" } : {};

  return (
    <div className="relative rounded-2xl overflow-hidden bg-gray-900 h-28">
      <Wrapper {...wrapperProps} className="relative block h-full w-full">
        <Image
          src={b.image_url}
          alt={b.title}
          fill
          sizes="(max-width: 768px) 100vw, 720px"
          className="object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/20 to-transparent" />
        <div className="absolute inset-0 flex flex-col justify-center px-5">
          <p className="text-white font-bold text-sm md:text-base line-clamp-1 drop-shadow">{b.title}</p>
          {b.subtitle && <p className="text-white/80 text-xs mt-0.5 line-clamp-1 drop-shadow">{b.subtitle}</p>}
        </div>
      </Wrapper>

      {count > 1 && (
        <>
          <button onClick={() => setCurrent((c) => (c - 1 + count) % count)}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-black/40 hover:bg-black/60 flex items-center justify-center text-white z-10">
            <ChevronLeft size={14} />
          </button>
          <button onClick={() => setCurrent((c) => (c + 1) % count)}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-black/40 hover:bg-black/60 flex items-center justify-center text-white z-10">
            <ChevronRight size={14} />
          </button>
          <div className="absolute bottom-2 right-3 flex gap-1 z-10">
            {banners.map((_, i) => (
              <button key={i} onClick={() => setCurrent(i)}
                className={`rounded-full transition-all ${i === current ? "w-4 h-1 bg-white" : "w-1 h-1 bg-white/50"}`} />
            ))}
          </div>
        </>
      )}

      <div className="absolute top-2 right-3 bg-black/30 backdrop-blur-sm text-white/70 text-[9px] px-1.5 py-0.5 rounded-full z-10">
        Реклама
      </div>
    </div>
  );
}
